export class DomUtils {
    public static GetInputElement(nativeElement: any): any {
        if (!nativeElement || !nativeElement.children) {
          return undefined;
        }
        if (!nativeElement.children.length && nativeElement.localName === 'input' && !nativeElement.hidden) {
          return nativeElement;
        }
        let input;

        [].slice.call(nativeElement.children).every(c => {
          input = this.GetInputElement(c);
          if (input) {
            return false; // break
          }
          return true; // continue!
        });

        return input;
    }
}
